/**
 * DOM text-node regex mutation is intentionally disabled.
 * All UI localization in apps/admin uses reactive Vue i18n ($t) dictionaries
 * so proper nouns (employee names, company names, SKUs) are never corrupted.
 */

export function translateString(text) {
  return text;
}

export function applyDomTranslation() {
  // Intentional no-op: reactive $t() handles all translations cleanly.
}

export function initDomTranslator() {
  // Intentional no-op: MutationObserver regex replacement disabled.
}
